import { useContext } from 'react';
import { SidePanelUiContext } from '@/core/deep-dive/contexts/side-panel-provider';
import { useEffectivePermissions } from '@/core/permissions/export';

export function useSidePanelTabs() {
  const sidePanelUi = useContext(SidePanelUiContext);
  const permissions = useEffectivePermissions();
  const isOpen = sidePanelUi.openPanelId !== null;

  const isRailBrowseActive = sidePanelUi.openPanelId === 'deep-dive' && sidePanelUi.isRailVisible;

  const isAppActive = (id: string) =>
    sidePanelUi.openPanelId === 'deep-dive' &&
    !sidePanelUi.isRailVisible &&
    sidePanelUi.selectedAppId === id;

  const toggleRail = () => {
    if (isRailBrowseActive) sidePanelUi.closePanel('deep-dive');
    else sidePanelUi.openRail();
  };

  const toggleApp = (id: string) => {
    if (isAppActive(id)) {
      sidePanelUi.closePanel('deep-dive');
    } else {
      sidePanelUi.openApp(id, false);
    }
  };

  return {
    sidePanelUi,
    permissions,
    isOpen,
    isRailBrowseActive,
    isAppActive,
    toggleRail,
    toggleApp,
  };
}
